/** 0–255 perceived brightness (same weights as ui-learner getContrastingColor). */
export const getLuminance = (bgColor) => {
  let color = bgColor.trim()

  if (color.startsWith('#')) color = color.slice(1)

  const rgbMatch = color.match(/^rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)/i)
  if (rgbMatch) {
    const r = Number(rgbMatch[1])
    const g = Number(rgbMatch[2])
    const b = Number(rgbMatch[3])
    return 0.299 * r + 0.587 * g + 0.114 * b
  }

  if (color.length === 3) {
    color = color.split('').map((c) => c + c).join('')
  }

  if (color.length < 6 || Number.isNaN(parseInt(color.slice(0, 2), 16))) {
    return 0
  }

  const r = parseInt(color.slice(0, 2), 16)
  const g = parseInt(color.slice(2, 4), 16)
  const b = parseInt(color.slice(4, 6), 16)

  return 0.299 * r + 0.587 * g + 0.114 * b
}

const BLACK = '#000000'
const WHITE = '#ffffff'
const DARK_SURFACE = '#1a171c'
const LIGHT_SURFACE = '#ffffff'
const ON_ACCENT_THRESHOLD = 150
const SURFACE_DELTA = 80
const EDGE_THRESHOLD = 220

export const getContrastingColor = (bgColor) =>
  getLuminance(bgColor) > ON_ACCENT_THRESHOLD ? BLACK : WHITE

const surfaceHex = (surfaceIsDark) => (surfaceIsDark ? DARK_SURFACE : LIGHT_SURFACE)

const contrastsWithSurface = (color, surfaceIsDark) =>
  Math.abs(getLuminance(color) - getLuminance(surfaceHex(surfaceIsDark))) >= SURFACE_DELTA

export const getAccentForeground = (accent, surfaceIsDark) => {
  if (contrastsWithSurface(accent, surfaceIsDark)) return accent
  return surfaceIsDark ? WHITE : BLACK
}

export const getFocusRingColors = (accent, surfaceIsDark) => {
  const ring = contrastsWithSurface(accent, surfaceIsDark)
    ? accent
    : (surfaceIsDark ? WHITE : BLACK)
  return { ring, inner: getContrastingColor(ring) }
}

export const getAccentEdge = (accent) =>
  getLuminance(accent) > EDGE_THRESHOLD ? '#000000' : 'transparent'

export const computeBrandContrastVars = (accentDark, surfaceIsDark) => {
  const { ring, inner } = getFocusRingColors(accentDark, surfaceIsDark)
  return {
    onAccent: getContrastingColor(accentDark),
    accentFg: getAccentForeground(accentDark, surfaceIsDark),
    accentOnLight: getAccentForeground(accentDark, false),
    focusRing: ring,
    focusRingInner: inner,
    accentEdge: getAccentEdge(accentDark),
  }
}
